__turbopack_context__.v({
  "className": "surahnames_b5b55305-module__si8-zW__className",
});
